import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import {
  Shield, Cloud, HeadphonesIcon, Activity, Database, Lightbulb, Globe, ArrowRight, Cable,
} from 'lucide-react';

const SERVICES = [
  { icon: HeadphonesIcon, title: 'Help Desk Support', desc: 'Fast, friendly support when you need it' },
  { icon: Activity, title: 'Network Monitoring', desc: '24/7 infrastructure health checks' },
  { icon: Shield, title: 'Cybersecurity', desc: 'Enterprise-grade protection' },
  { icon: Cloud, title: 'Cloud Services', desc: 'Microsoft 365 & Azure experts' },
  { icon: Database, title: 'Backup & Recovery', desc: 'Never lose critical data' },
  { icon: Cable, title: 'Structured Cabling', desc: 'Cat6/Fiber installation & infrastructure' },
  { icon: Lightbulb, title: 'IT Consulting', desc: 'Strategic technology planning' },
  { icon: Globe, title: 'Website Design', desc: 'Professional websites from $550' },
];

export function ServicesPreview() {
  return (
    <section className="py-24 bg-white" data-testid="services-preview-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-black text-slate-900 mb-4" style={{ fontFamily: 'Chivo, sans-serif' }}>
            Complete IT Solutions for Your Business
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            From help desk support to advanced cybersecurity, we've got every aspect of your IT infrastructure covered.
          </p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {SERVICES.map((service) => {
            const isWebsite = service.title === 'Website Design';
            return (
              <Card
                key={service.title}
                className={`premium-card ${isWebsite ? 'bg-gradient-to-br from-cyan-50 to-blue-50 border-cyan-200' : 'bg-white'}`}
                data-testid={`service-card-${service.title.toLowerCase().replace(/\s/g, '-')}`}
              >
                <CardContent className="p-6">
                  <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-4 ${
                    isWebsite ? 'bg-gradient-to-br from-cyan-500 to-blue-600' : 'bg-blue-100'
                  }`}>
                    <service.icon className={`w-6 h-6 ${isWebsite ? 'text-white' : 'text-blue-600'}`} />
                  </div>
                  <h3 className="text-base font-bold text-slate-900 mb-1" style={{ fontFamily: 'Chivo, sans-serif' }}>
                    {service.title}
                  </h3>
                  <p className="text-slate-600 text-sm">{service.desc}</p>
                  {isWebsite && (
                    <span className="inline-block mt-3 text-xs font-bold text-cyan-600 bg-cyan-100 px-2 py-1 rounded-full">
                      Starting at $550
                    </span>
                  )}
                </CardContent>
              </Card>
            );
          })}
        </div>
        <div className="text-center mt-12">
          <Link to="/services">
            <Button size="lg" className="bg-blue-600 hover:bg-blue-700 text-white font-semibold shadow-lg shadow-blue-500/20 btn-hover-lift" data-testid="view-all-services-btn">
              View All Services <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
